<template>
<div>
  <div @click="fireClickEvent" id="custom-map-guard">
    <div v-bind:style="backgroundStyle">
      <div class="p-2 fixed-top" :style="headerStyle" v-if="callToActionType == 'banner'">
        <div class="text-lg text-center text-white">
          <span class="font-weight-bold">{{name}}</span>
          <span>— Click to activate</span>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: ['name', 'url', 'callToActionType'],

  computed: {
    backgroundStyle() {
      return {
        "position": 'relative',
        "background": `url("${this.url}") no-repeat center center`,
        "background-size": "cover",
        "padding": '8rem',
        "height": '100vh',
        "cursor": "pointer"
      };
    },

    headerStyle() {
      return {
        "background-color": "rgba(0, 0, 0, 0.5)"
      }
    },
  },

  data() {
    return {
      overlay: {
        "position": "absolute",
        "height": "100%",
        "width": "100%",
        "top": 0,
        "left": 0,
        "background-color": "rgba(0, 0, 0, 0.7)"
      }
    }
  },

  methods: {
    fireClickEvent(event) {
      this.$emit('custom-image-clicked', event);
    }
  }
}
</script>
